import { render, staticRenderFns } from "./match2023m.vue?vue&type=template&id=ec0ccd1c&scoped=true"
import script from "./match2023m.vue?vue&type=script&lang=js"
export * from "./match2023m.vue?vue&type=script&lang=js"
import style0 from "./match2023m.vue?vue&type=style&index=0&id=ec0ccd1c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec0ccd1c",
  null
  
)

export default component.exports